var _style, _path, _feBlend, _feBlend2, _feBlend3, _feBlend4, _feBlend5, _feBlend6, _feBlend7, _feBlend8, _feBlend9, _feBlend10, _feBlend11, _feBlend12, _feBlend13, _feBlend14, _feBlend15, _feBlend16, _feBlend17, _feBlend18, _feBlend19, _feBlend20, _feBlend21, _feBlend22, _feBlend23, _feBlend24, _feBlend25, _feBlend26, _feBlend27, _feBlend28, _feBlend29, _feBlend30, _feBlend31, _feBlend32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeWidget1 = function SvgHomeWidget1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1_kopie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.9 243.3",
    style: {
      enableBackground: "new 0 0 115.9 243.3"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000132773944105128544360000001621835891149189310_);}\r\n\t.st2{fill:url(#SVGID_00000036222536635890688550000014318276068901040312_);}\r\n\t.st3{fill:url(#SVGID_00000072992162898405572390000014007380871839095726_);}\r\n\t.st4{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000026852982180040307220000011881588004833624705_);}\r\n\t\r\n\t\t.st6{mask:url(#SVGID_00000145052093036586039900000003157422541974200990_);fill:url(#SVGID_00000170244950645104566980000004793100587784550547_);}\r\n\t.st7{fill:url(#SVGID_00000057859014223319714690000014840275900260477075_);}\r\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000070114773601983119960000013934498122140580785_);}\r\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_00000038373081098916411580000000835854160779903657_);}\r\n\t\r\n\t\t.st10{mask:url(#SVGID_00000079469425329177902320000006396044154140007863_);fill:url(#SVGID_00000020374570506291544490000005575945008884586430_);}\r\n\t.st11{fill:url(#SVGID_00000045614976789179746130000000485073888390166204_);}\r\n\t.st12{fill:url(#SVGID_00000061465168481007409490000010739970226908083135_);}\r\n\t.st13{filter:url(#Adobe_OpacityMaskFilter_00000043456067843213782340000005578259721168890766_);}\r\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_00000046310212122589490620000004634883504376549526_);}\r\n\t\r\n\t\t.st15{mask:url(#SVGID_00000038412960174345962990000014170080565302866861_);fill:url(#SVGID_00000180353293384996422470000011474318039431526023_);}\r\n\t.st16{fill:url(#SVGID_00000046301142268136956740000013008046943541798324_);}\r\n\t.st17{fill:url(#SVGID_00000163032087556508202380000010171355897063582903_);}\r\n\t.st18{fill:url(#SVGID_00000124157344339291529540000004317652672865271205_);}\r\n\t.st19{fill:url(#SVGID_00000020362591432198351930000012139576018895245961_);}\r\n\t.st20{filter:url(#Adobe_OpacityMaskFilter_00000069394687769197725480000000349166064356146359_);}\r\n\t.st21{filter:url(#Adobe_OpacityMaskFilter_00000036956648577557602910000000454328661019459482_);}\r\n\t\r\n\t\t.st22{mask:url(#SVGID_00000040576217390031432220000006421161604103719040_);fill:url(#SVGID_00000063607815598380778140000005628408667849919382_);}\r\n\t.st23{fill:url(#SVGID_00000018940303351658370310000004053126625947676069_);}\r\n\t.st24{filter:url(#Adobe_OpacityMaskFilter_00000125584299702323210150000012439115465011775386_);}\r\n\t.st25{filter:url(#Adobe_OpacityMaskFilter_00000147924781541422656230000009279955374737308547_);}\r\n\t\r\n\t\t.st26{mask:url(#SVGID_00000008139270577350246830000014873292853027136664_);fill:url(#SVGID_00000092419576929868114480000010664580325419381945_);}\r\n\t.st27{opacity:0.48;fill:url(#SVGID_00000078044300078350104470000017323833109979827354_);}\r\n\t.st28{fill:url(#SVGID_00000004537271928129674620000011870773977287235514_);}\r\n\t.st29{fill:url(#SVGID_00000008837434153570452390000013082297957933345675_);}\r\n\t.st30{filter:url(#Adobe_OpacityMaskFilter_00000043433747304684088430000015656918478445773456_);}\r\n\t.st31{filter:url(#Adobe_OpacityMaskFilter_00000029041512220564478520000009772764271996783280_);}\r\n\t\r\n\t\t.st32{mask:url(#SVGID_00000006684669764239385790000016050644442382739369_);fill:url(#SVGID_00000037654997586574543010000013227069207456342434_);}\r\n\t.st33{fill:url(#SVGID_00000101072199801842513880000007466415427231406227_);}\r\n\t.st34{fill:url(#SVGID_00000183245711271791480610000002680725338611102887_);}\r\n\t.st35{fill:url(#SVGID_00000005977869596146539090000013697924188630995636_);}\r\n\t.st36{filter:url(#Adobe_OpacityMaskFilter_00000011018757668149090940000008541189462308694677_);}\r\n\t.st37{filter:url(#Adobe_OpacityMaskFilter_00000145043817636219581540000008010443275276126850_);}\r\n\t\r\n\t\t.st38{mask:url(#SVGID_00000071524375240123263780000001442213534381530552_);fill:url(#SVGID_00000007420814599899797420000011877278936655327884_);}\r\n\t.st39{opacity:0.48;fill:url(#SVGID_00000008137290556277725290000015934128266040730768_);}\r\n\t.st40{filter:url(#Adobe_OpacityMaskFilter_00000114774553645776099620000017771543703825521041_);}\r\n\t.st41{filter:url(#Adobe_OpacityMaskFilter_00000156554909223410684720000000929094240604626618_);}\r\n\t\r\n\t\t.st42{mask:url(#SVGID_00000048500639663894647730000003704872936023865230_);fill:url(#SVGID_00000093136533851641454300000014103660136004979893_);}\r\n\t.st43{opacity:0.48;fill:url(#SVGID_00000022552155062110300330000015146015201785689999_);}\r\n\t.st44{fill:url(#SVGID_00000101817322836346013460000005404585121549042561_);}\r\n\t.st45{fill:url(#SVGID_00000168818057644777745970000011446444653451824062_);}\r\n\t.st46{fill:url(#SVGID_00000150090873765435376560000010144483184879773847_);}\r\n\t.st47{fill:url(#SVGID_00000042704492502295301530000008609275274096171692_);}\r\n\t.st48{filter:url(#Adobe_OpacityMaskFilter_00000081647116923678478560000002394581764243778209_);}\r\n\t.st49{filter:url(#Adobe_OpacityMaskFilter_00000101084238343523088560000012030074806912682902_);}\r\n\t\r\n\t\t.st50{mask:url(#SVGID_00000049943762329489952250000009998911284546461626_);fill:url(#SVGID_00000091713537891446758780000006046239842896985506_);}\r\n\t.st51{fill:url(#SVGID_00000156579248394019881360000015144760114563997099_);}\r\n\t.st52{filter:url(#Adobe_OpacityMaskFilter_00000129207721163470974090000009675160393963078800_);}\r\n\t.st53{filter:url(#Adobe_OpacityMaskFilter_00000095314999324174287860000005003399281752617101_);}\r\n\t\r\n\t\t.st54{mask:url(#SVGID_00000031170935376901995300000000367757177585799600_);fill:url(#SVGID_00000118381444419133185630000006032508666940400045_);}\r\n\t.st55{fill:url(#SVGID_00000084504770802606186110000007748901903557909905_);}\r\n\t.st56{fill:url(#SVGID_00000048476270813824321010000014268986826518909104_);}\r\n\t.st57{filter:url(#Adobe_OpacityMaskFilter_00000080192035249297375360000014600844443383257272_);}\r\n\t.st58{filter:url(#Adobe_OpacityMaskFilter_00000019678685779519038610000006296669898928426143_);}\r\n\t\r\n\t\t.st59{mask:url(#SVGID_00000167379933596948696020000002179056139553822601_);fill:url(#SVGID_00000018952250893393641790000008904135395911433913_);}\r\n\t.st60{fill:url(#SVGID_00000121252346032850577550000007835574681369519530_);}\r\n\t.st61{fill:url(#SVGID_00000116919381123698324420000017492288012064976806_);}\r\n\t.st62{fill:url(#SVGID_00000120553613109768437810000012755803116074796471_);}\r\n\t.st63{fill:url(#SVGID_00000098938059054317484870000007249427945420665238_);}\r\n\t.st64{filter:url(#Adobe_OpacityMaskFilter_00000057120208680396705110000005103428152586575518_);}\r\n\t.st65{filter:url(#Adobe_OpacityMaskFilter_00000057826552668762054750000009962142335679900050_);}\r\n\t\r\n\t\t.st66{mask:url(#SVGID_00000158021595703360126250000002497593903549065379_);fill:url(#SVGID_00000084504394573433479640000014969312753854214312_);}\r\n\t.st67{fill:url(#SVGID_00000135690242903659624360000014842939064999578276_);}\r\n\t.st68{filter:url(#Adobe_OpacityMaskFilter_00000054978080198978334130000018282290888197452443_);}\r\n\t.st69{filter:url(#Adobe_OpacityMaskFilter_00000010308638267415096710000002783180073696203401_);}\r\n\t\r\n\t\t.st70{mask:url(#SVGID_00000015331261840142867770000003231007166057266618_);fill:url(#SVGID_00000000207601552776186480000013849627243562708368_);}\r\n\t.st71{opacity:0.48;fill:url(#SVGID_00000119829024314580705450000015112628780835697306_);}\r\n\t.st72{fill:url(#SVGID_00000183251236620143292240000005041685938981363376_);}\r\n\t.st73{fill:url(#SVGID_00000013899715978027911020000004617432328740413836_);}\r\n\t.st74{filter:url(#Adobe_OpacityMaskFilter_00000079456696815961724920000015280554700329660590_);}\r\n\t.st75{filter:url(#Adobe_OpacityMaskFilter_00000016786288599139709580000011041755329988022162_);}\r\n\t\r\n\t\t.st76{mask:url(#SVGID_00000111874600176926379940000013769899356494349978_);fill:url(#SVGID_00000083789772623234769120000017585951571420787127_);}\r\n\t.st77{fill:url(#SVGID_00000181062541788309515800000003404848198103602359_);}\r\n\t.st78{fill:url(#SVGID_00000160161623399602754360000018338741291776599691_);}\r\n\t.st79{fill:url(#SVGID_00000025441751571993040830000004700966607887230860_);}\r\n\t.st80{filter:url(#Adobe_OpacityMaskFilter_00000052089943412317701550000005181824644167966853_);}\r\n\t.st81{filter:url(#Adobe_OpacityMaskFilter_00000000194718692710617670000002558954581842726019_);}\r\n\t\r\n\t\t.st82{mask:url(#SVGID_00000115498184478800663240000009698305547471689891_);fill:url(#SVGID_00000023996096975258514430000006165892728805379237_);}\r\n\t.st83{opacity:0.48;fill:url(#SVGID_00000052820754857656694610000007457250515121925528_);}\r\n\t.st84{filter:url(#Adobe_OpacityMaskFilter_00000157995263517633877380000006972484295886448809_);}\r\n\t.st85{filter:url(#Adobe_OpacityMaskFilter_00000181069028163336567700000000331258937162744200_);}\r\n\t\r\n\t\t.st86{mask:url(#SVGID_00000160903870020168990530000000712234189012312235_);fill:url(#SVGID_00000036220650628786480610000009538460800038715551_);}\r\n\t.st87{opacity:0.48;fill:url(#SVGID_00000016055158077458133820000015212267785726662285_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.4801,
    y1: 130.9889,
    x2: 29.4801,
    y2: 98.3077,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.7,97.9c0,0,2.4,13.2-6.2,33.1c0,0-7.6-12.6-6-33.1H93.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000050642796866247441690000002039186818452308897_",
    cx: 313.5531,
    cy: -905.6005,
    r: 0,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050642796866247441690000002039186818452308897_)"
    },
    d: "M78.7,25.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054237490777685366250000013566501489439052734_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.8354,
    y1: 69.9555,
    x2: 11.8354,
    y2: 100.1272,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054237490777685366250000013566501489439052734_)"
    },
    points: "98.2,89.7 112.4,101.9  106.9,71.7 101.9,69.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065761080643733131730000015794390428350471316_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.2997,
    y1: 69.9555,
    x2: 47.2997,
    y2: 100.1272,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065761080643733131730000015794390428350471316_)"
    },
    points: "76.9,89.7 62.8,101.9  68.3,71.7 73.3,69.2  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 67.7,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 67.7,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000168090118514872913840000000914772545229635725_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000029036275603415244400000016755845429677213355_",
    filterUnits: "userSpaceOnUse",
    x: 67.7,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 67.7,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000168090118514872913840000000914772545229635725_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000029036275603415244400000016755845429677213355_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098195268288743265400000006248765049512569274_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.9658,
    y1: -845.4188,
    x2: 294.0706,
    y2: -854.902,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000168090118514872913840000000914772545229635725_)",
      fill: "url(#SVGID_00000098195268288743265400000006248765049512569274_)"
    },
    points: " 71.3,70.2 70.1,70.8 67.7,97.7 75.5,91  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039107048960489728000000000494975346701950874_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.9658,
    y1: -845.4188,
    x2: 294.0706,
    y2: -854.902,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039107048960489728000000000494975346701950874_)"
    },
    points: "71.3,70.2 70.1,70.8  67.7,97.7 75.5,91  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000067198841985918000310000002959510271813152418_",
    filterUnits: "userSpaceOnUse",
    x: 99.6,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 99.6,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000173154657152107513760000012108391931171434140_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000067198841985918000310000002959510271813152418_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000118381641317008182030000016915322776303390610_",
    filterUnits: "userSpaceOnUse",
    x: 99.6,
    y: 70.2,
    width: 7.8,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 99.6,
    y: 70.2,
    width: 7.8,
    height: 27.5,
    id: "SVGID_00000173154657152107513760000012108391931171434140_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000118381641317008182030000016915322776303390610_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085242029505431525050000004415778779842380179_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.2968,
    y1: -842.295,
    x2: 284.3867,
    y2: -899.3831,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000173154657152107513760000012108391931171434140_)",
      fill: "url(#SVGID_00000085242029505431525050000004415778779842380179_)"
    },
    points: " 103.9,70.2 105,70.8 107.4,97.7 99.6,91  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080909083531676837860000007382981233707092101_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.2968,
    y1: -842.295,
    x2: 284.3867,
    y2: -899.3831,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000080909083531676837860000007382981233707092101_)"
    },
    points: "103.9,70.2 105,70.8  107.4,97.7 99.6,91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113314561928993790930000015515084060281321628_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5347,
    y1: 96.5422,
    x2: 29.5347,
    y2: 92.303,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000113314561928993790930000015515084060281321628_)"
    },
    points: "77.5,96.8 97.7,96.8  97.7,91.4 77.5,91.4  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000183206945276259966660000014606597836467416458_",
    filterUnits: "userSpaceOnUse",
    x: 77.5,
    y: 91.4,
    width: 20.2,
    height: 5.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 77.5,
    y: 91.4,
    width: 20.2,
    height: 5.4,
    id: "SVGID_00000070834630792958268740000005184997534790619520_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000183206945276259966660000014606597836467416458_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000010287646625985121700000012373935242070236065_",
    filterUnits: "userSpaceOnUse",
    x: 77.5,
    y: 91.4,
    width: 20.2,
    height: 5.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 77.5,
    y: 91.4,
    width: 20.2,
    height: 5.4,
    id: "SVGID_00000070834630792958268740000005184997534790619520_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000010287646625985121700000012373935242070236065_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016774393594131906260000004322214482673101965_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.89,
    y1: -832.5776,
    x2: 302.8709,
    y2: -872.4995,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000070834630792958268740000005184997534790619520_)",
      fill: "url(#SVGID_00000016774393594131906260000004322214482673101965_)"
    },
    points: " 97.7,91.4 77.5,91.4 77.5,96.8 79,96.8 79,93.1 97.7,93.1  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181800479968537724230000000158405042379085239_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.89,
    y1: -832.5776,
    x2: 302.8709,
    y2: -872.4995,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181800479968537724230000000158405042379085239_)"
    },
    points: "97.7,91.4 77.5,91.4  77.5,96.8 79,96.8 79,93.1 97.7,93.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150808081928651443370000012836757837704489614_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9178,
    y1: 97.3669,
    x2: 38.1515,
    y2: 97.3669,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000150808081928651443370000012836757837704489614_)"
    },
    points: "79,97.9 96.2,97.9 96.2,96.8  79,96.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132058053011330905490000001773914359116832948_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5673,
    y1: 87.8544,
    x2: 29.5673,
    y2: 42.9324,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132058053011330905490000001773914359116832948_)"
    },
    d: "M71.9,34.8C76.4,16.4,87.4,3.3,87.6,3 c0,0,0,0,0,0v0c0,0,11.2,13.2,15.7,31.8c1.1,4.7,1.8,9.8,1.8,15c0,4.7-0.2,9-0.5,12.9c-1.3,18.3-5.1,28.6-5.1,28.6h-12v0h-12 c0,0-3.7-10.3-5.1-28.6c-0.3-3.9-0.5-8.3-0.5-12.9C70.1,44.6,70.8,39.5,71.9,34.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164501696053173953210000001064879727688379289_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.2472,
    y1: -912.462,
    x2: 272.8063,
    y2: -907.3787,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164501696053173953210000001064879727688379289_)"
    },
    d: "M71.9,34.8c5,1.5,10.2,2.3,15.7,2.3 c5.5,0,10.7-0.8,15.7-2.3C98.8,16.2,87.6,3,87.6,3S76.4,16.2,71.9,34.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000019651179756154109950000007830889347057297842_",
    filterUnits: "userSpaceOnUse",
    x: 70.1,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 70.1,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000148627185981706535350000002430227309125322145_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000019651179756154109950000007830889347057297842_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000127022734496281046560000009758115168766488977_",
    filterUnits: "userSpaceOnUse",
    x: 70.1,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 70.1,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000148627185981706535350000002430227309125322145_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000127022734496281046560000009758115168766488977_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179621687543158960600000013068860831361036221_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.1321,
    y1: -894.4223,
    x2: 450.4134,
    y2: -765.2964,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000148627185981706535350000002430227309125322145_)",
      fill: "url(#SVGID_00000179621687543158960600000013068860831361036221_)"
    },
    d: " M70.1,49.9c0,4.7,0.2,9,0.5,12.9c1.3,18.3,5.1,28.6,5.1,28.6h4.9C67.5,44.8,87.4,3.5,87.6,3c-0.2,0.3-11.2,13.3-15.7,31.8 C70.8,39.5,70.1,44.6,70.1,49.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018225496570846560580000008952430140322228156_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.1321,
    y1: -894.4223,
    x2: 450.4134,
    y2: -765.2964,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018225496570846560580000008952430140322228156_)"
    },
    d: "M70.1,49.9c0,4.7,0.2,9,0.5,12.9 c1.3,18.3,5.1,28.6,5.1,28.6h4.9C67.5,44.8,87.4,3.5,87.6,3c-0.2,0.3-11.2,13.3-15.7,31.8C70.8,39.5,70.1,44.6,70.1,49.9z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000155132467319786931270000000136633781709247649_",
    filterUnits: "userSpaceOnUse",
    x: 87.5,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 87.5,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000140721031191577034530000010578695426677105282_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000155132467319786931270000000136633781709247649_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000161601792337049768850000009370906951958440091_",
    filterUnits: "userSpaceOnUse",
    x: 87.5,
    y: 3,
    width: 17.5,
    height: 88.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 87.5,
    y: 3,
    width: 17.5,
    height: 88.4,
    id: "SVGID_00000140721031191577034530000010578695426677105282_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000161601792337049768850000009370906951958440091_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090270219086948615550000010502024453339642548_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6423,
    y1: -869.2474,
    x2: 261.4683,
    y2: -961.1441,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000140721031191577034530000010578695426677105282_)",
      fill: "url(#SVGID_00000090270219086948615550000010502024453339642548_)"
    },
    d: " M105,49.9c0,4.7-0.2,9-0.5,12.9c-1.3,18.3-5.1,28.6-5.1,28.6h-4.9c13.1-46.6-6.8-87.9-7-88.4c0.2,0.3,11.2,13.3,15.7,31.8 C104.3,39.5,105,44.6,105,49.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099651115586588466860000011556605397455830939_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6423,
    y1: -869.2474,
    x2: 261.4683,
    y2: -961.1441,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000099651115586588466860000011556605397455830939_)"
    },
    d: "M105,49.9 c0,4.7-0.2,9-0.5,12.9c-1.3,18.3-5.1,28.6-5.1,28.6h-4.9c13.1-46.6-6.8-87.9-7-88.4c0.2,0.3,11.2,13.3,15.7,31.8 C104.3,39.5,105,44.6,105,49.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159433836671607310170000005411544776312534923_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9748,
    y1: 81.9404,
    x2: 28.9748,
    y2: 97.5897,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000159433836671607310170000005411544776312534923_)"
    },
    points: "87.6,68.2 87.6,106  88.8,94.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168806931431148133730000015587369162377947555_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.1617,
    y1: 98.2693,
    x2: 30.1617,
    y2: 86.2319,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168806931431148133730000015587369162377947555_)"
    },
    points: "87.6,68.2 87.6,106  86.4,94.9  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000166676182566899255400000003307794752465406639_",
    filterUnits: "userSpaceOnUse",
    x: 79.5,
    y: 42,
    width: 15.3,
    height: 15.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 79.5,
    y: 42,
    width: 15.3,
    height: 15.3,
    id: "SVGID_00000149354536783844374800000005841663092557757370_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000166676182566899255400000003307794752465406639_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000153700882650402783530000011210985347933072524_",
    filterUnits: "userSpaceOnUse",
    x: 79.5,
    y: 42,
    width: 15.3,
    height: 15.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 79.5,
    y: 42,
    width: 15.3,
    height: 15.3,
    id: "SVGID_00000149354536783844374800000005841663092557757370_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000153700882650402783530000011210985347933072524_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173838996798453569110000017114805934720726162_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.754,
    y1: -878.0123,
    x2: 269.6029,
    y2: -904.7644,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      mask: "url(#SVGID_00000149354536783844374800000005841663092557757370_)",
      fill: "url(#SVGID_00000173838996798453569110000017114805934720726162_)"
    },
    cx: 87.1,
    cy: 49.7,
    r: 7.6
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164494715681260381090000013832464281527370422_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.754,
    y1: -878.0123,
    x2: 269.6029,
    y2: -904.7644,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000164494715681260381090000013832464281527370422_)"
    },
    cx: 87.1,
    cy: 49.7,
    r: 7.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119834710534540485370000004256705932855593386_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5682,
    y1: 42.1126,
    x2: 29.5682,
    y2: 53.3248,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000119834710534540485370000004256705932855593386_)"
    },
    cx: 87.6,
    cy: 49.2,
    r: 7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157277311113092725730000017017008418932334267_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.0426,
    y1: 53.0971,
    x2: 28.4314,
    y2: 47.4448,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157277311113092725730000017017008418932334267_)"
    },
    d: "M82.6,49.2c0,2.7,2.2,5,5,5 c0.5,0,1-0.1,1.5-0.2c0.6-0.2,1.2-0.5,1.7-0.9c0.4-0.3,0.7-0.7,1-1.1c0.5-0.8,0.8-1.7,0.8-2.7c0-2.7-2.2-5-5-5 c-1,0-1.9,0.3-2.7,0.8c-0.4,0.3-0.8,0.6-1.1,1c-0.4,0.5-0.7,1.1-0.9,1.7C82.7,48.2,82.6,48.7,82.6,49.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000074403062304920763490000016109314362673117827_",
    filterUnits: "userSpaceOnUse",
    x: 84.9,
    y: 44.3,
    width: 7.7,
    height: 7.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 84.9,
    y: 44.3,
    width: 7.7,
    height: 7.7,
    id: "SVGID_00000176748337272454892880000016605203048455535237_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000074403062304920763490000016109314362673117827_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156573327710978630650000008702333187323982238_",
    filterUnits: "userSpaceOnUse",
    x: 84.9,
    y: 44.3,
    width: 7.7,
    height: 7.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 84.9,
    y: 44.3,
    width: 7.7,
    height: 7.7,
    id: "SVGID_00000176748337272454892880000016605203048455535237_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000156573327710978630650000008702333187323982238_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121994658222666438890000001150692302609186996_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0987,
    y1: -889.3186,
    x2: 281.9336,
    y2: -865.3962,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000176748337272454892880000016605203048455535237_)",
      fill: "url(#SVGID_00000121994658222666438890000001150692302609186996_)"
    },
    d: " M84.9,45.1l6.9,6.9c0.5-0.8,0.8-1.7,0.8-2.7c0-2.7-2.2-5-5-5C86.6,44.3,85.7,44.5,84.9,45.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104696209992770302350000017538540476484573626_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.0987,
    y1: -889.3186,
    x2: 281.9336,
    y2: -865.3962,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000104696209992770302350000017538540476484573626_)"
    },
    d: "M84.9,45.1l6.9,6.9 c0.5-0.8,0.8-1.7,0.8-2.7c0-2.7-2.2-5-5-5C86.6,44.3,85.7,44.5,84.9,45.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000163068688416949066560000008224361557625598133_",
    filterUnits: "userSpaceOnUse",
    x: 82.8,
    y: 46,
    width: 7.9,
    height: 7.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 82.8,
    y: 46,
    width: 7.9,
    height: 7.9,
    id: "SVGID_00000057118946987297657570000008157364799339023750_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000163068688416949066560000008224361557625598133_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000163048929433204502920000000066314390764059307_",
    filterUnits: "userSpaceOnUse",
    x: 82.8,
    y: 46,
    width: 7.9,
    height: 7.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 82.8,
    y: 46,
    width: 7.9,
    height: 7.9,
    id: "SVGID_00000057118946987297657570000008157364799339023750_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000163048929433204502920000000066314390764059307_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018194619962504238780000005281887079911343038_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.7074,
    y1: -887.1619,
    x2: 306.91,
    y2: -865.8091,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000057118946987297657570000008157364799339023750_)",
      fill: "url(#SVGID_00000018194619962504238780000005281887079911343038_)"
    },
    d: " M82.8,47.7l6.3,6.2c0.6-0.2,1.2-0.5,1.7-0.9l-7-7C83.4,46.5,83,47.1,82.8,47.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139994992664264874800000009095162027398611094_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.7074,
    y1: -887.1619,
    x2: 306.91,
    y2: -865.8091,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000139994992664264874800000009095162027398611094_)"
    },
    d: "M82.8,47.7l6.3,6.2 c0.6-0.2,1.2-0.5,1.7-0.9l-7-7C83.4,46.5,83,47.1,82.8,47.7z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097487681602022456050000005794605922170591386_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.3931,
    y1: 240.2038,
    x2: 67.3931,
    y2: 180.3987,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00193075,
    style: {
      stopColor: "#F9EF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5A017"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097487681602022456050000005794605922170591386_)"
    },
    d: "M60.8,179.6c0,0,4.4,24.2-11.3,60.7 c0,0-14-23.1-11-60.7H60.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000162329033425350286260000008346965744321055164_",
    cx: 358.9522,
    cy: -884.1786,
    r: 0,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#6220FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#14161C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162329033425350286260000008346965744321055164_)"
    },
    d: "M33.3,46.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010298950363795097930000014153305203722117007_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.1042,
    y1: 128.5154,
    x2: 35.1042,
    y2: 183.7283,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000010298950363795097930000014153305203722117007_)"
    },
    points: "69.1,164.7 95,186.9  84.9,131.6 75.8,127.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106115274589688873530000013215819339906598051_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.0022,
    y1: 128.5154,
    x2: 100.0022,
    y2: 183.7283,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000106115274589688873530000013215819339906598051_)"
    },
    points: "30.1,164.7 4.2,186.9  14.3,131.6 23.4,127.1  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000131353894916691547070000005942410075021663638_",
    filterUnits: "userSpaceOnUse",
    x: 13.2,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13.2,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000052100155469228960460000010232246987978874501_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000131353894916691547070000005942410075021663638_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000170967332755302563690000010005188352314277795_",
    filterUnits: "userSpaceOnUse",
    x: 13.2,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 13.2,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000052100155469228960460000010232246987978874501_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000170967332755302563690000010005188352314277795_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062165791676477379640000000495256011341827757_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.3268,
    y1: -774.0488,
    x2: 323.3,
    y2: -791.4028,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000052100155469228960460000010232246987978874501_)",
      fill: "url(#SVGID_00000062165791676477379640000000495256011341827757_)"
    },
    points: " 19.7,128.9 17.6,130 13.2,179.2 27.5,167  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048462034903098961460000017727839723884971932_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.3268,
    y1: -774.0488,
    x2: 323.3,
    y2: -791.4028,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000048462034903098961460000017727839723884971932_)"
    },
    points: "19.7,128.9 17.6,130  13.2,179.2 27.5,167  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000010312355412695627220000017416419776265938367_",
    filterUnits: "userSpaceOnUse",
    x: 71.6,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 71.6,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000016062669639454970130000017888865334305581235_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000010312355412695627220000017416419776265938367_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052786831758465848660000005279038205373649810_",
    filterUnits: "userSpaceOnUse",
    x: 71.6,
    y: 128.9,
    width: 14.2,
    height: 50.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 71.6,
    y: 128.9,
    width: 14.2,
    height: 50.3,
    id: "SVGID_00000016062669639454970130000017888865334305581235_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000052786831758465848660000005279038205373649810_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036944261558946052190000010778764538158844573_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7342,
    y1: -768.3323,
    x2: 305.5789,
    y2: -872.801,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000016062669639454970130000017888865334305581235_)",
      fill: "url(#SVGID_00000036944261558946052190000010778764538158844573_)"
    },
    points: " 79.4,128.9 81.5,130 85.9,179.2 71.6,167  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017508983996009304530000014654817069856962726_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7342,
    y1: -768.3323,
    x2: 305.5789,
    y2: -872.801,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000017508983996009304530000014654817069856962726_)"
    },
    points: "79.4,128.9 81.5,130  85.9,179.2 71.6,167  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180341788484666406830000014546342828015527811_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.493,
    y1: 177.1679,
    x2: 67.493,
    y2: 169.4103,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000180341788484666406830000014546342828015527811_)"
    },
    points: "31.2,177.7 68.2,177.7  68.2,167.7 31.2,167.7  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026874370222074284490000014237785450430692752_",
    filterUnits: "userSpaceOnUse",
    x: 31.2,
    y: 167.7,
    width: 37,
    height: 10
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 31.2,
    y: 167.7,
    width: 37,
    height: 10,
    id: "SVGID_00000096039329313520438890000010994889134738618515_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000026874370222074284490000014237785450430692752_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000125598613290127669840000003413322843531199423_",
    filterUnits: "userSpaceOnUse",
    x: 31.2,
    y: 167.7,
    width: 37,
    height: 10
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 31.2,
    y: 167.7,
    width: 37,
    height: 10,
    id: "SVGID_00000096039329313520438890000010994889134738618515_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000125598613290127669840000003413322843531199423_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069393853311808790580000009495031266579928194_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.099,
    y1: -750.5501,
    x2: 339.4042,
    y2: -823.6052,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000096039329313520438890000010994889134738618515_)",
      fill: "url(#SVGID_00000069393853311808790580000009495031266579928194_)"
    },
    points: " 68.2,167.7 31.2,167.7 31.2,177.7 33.9,177.7 33.9,170.9 68.2,170.9  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085218736824951444190000008740524978243560085_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.099,
    y1: -750.5501,
    x2: 339.4042,
    y2: -823.6052,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085218736824951444190000008740524978243560085_)"
    },
    points: "68.2,167.7 31.2,167.7  31.2,177.7 33.9,177.7 33.9,170.9 68.2,170.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039132245750357406340000005057871025617097140_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7246,
    y1: 178.677,
    x2: 83.2614,
    y2: 178.677,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039132245750357406340000005057871025617097140_)"
    },
    points: "33.9,179.6 65.4,179.6  65.4,177.7 33.9,177.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089556403724231000020000015219211553672631692_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5528,
    y1: 161.2697,
    x2: 67.5528,
    y2: 79.0645,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089556403724231000020000015219211553672631692_)"
    },
    d: "M20.9,64.2C29.1,30.4,49.2,6.5,49.6,6 c0,0,0,0,0,0v0c0,0,20.4,24.1,28.7,58.2c2.1,8.6,3.4,17.8,3.4,27.5c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3H49.6 v0H27.7c0,0-6.9-18.9-9.3-52.3c-0.5-7.2-0.8-15.1-0.8-23.7C17.6,82.1,18.9,72.8,20.9,64.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147203212580200059080000001810328844875233717_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.6919,
    y1: -896.7348,
    x2: 284.3875,
    y2: -887.4327,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147203212580200059080000001810328844875233717_)"
    },
    d: "M21,64.2c9.1,2.8,18.7,4.3,28.7,4.3 c10,0,19.6-1.5,28.7-4.3C70,30.1,49.6,6,49.6,6S29.2,30.1,21,64.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000089566169039514491570000009415990472479605180_",
    filterUnits: "userSpaceOnUse",
    x: 17.6,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 17.6,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000175322581089865515800000005148896983786533806_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000089566169039514491570000009415990472479605180_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000179611027101801669500000012053201848847489976_",
    filterUnits: "userSpaceOnUse",
    x: 17.6,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 17.6,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000175322581089865515800000005148896983786533806_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000179611027101801669500000012053201848847489976_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051381756182321259840000017059448104319519617_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.2426,
    y1: -863.723,
    x2: 609.4003,
    y2: -627.4285,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000175322581089865515800000005148896983786533806_)",
      fill: "url(#SVGID_00000051381756182321259840000017059448104319519617_)"
    },
    d: " M17.6,91.7c0,8.5,0.3,16.4,0.8,23.7c2.4,33.4,9.3,52.3,9.3,52.3h9C12.8,82.5,49.2,6.9,49.6,6c-0.4,0.5-20.5,24.4-28.7,58.2 C18.9,72.8,17.6,82.1,17.6,91.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025415722376102461910000017213755865796066214_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.2426,
    y1: -863.723,
    x2: 609.4003,
    y2: -627.4285,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025415722376102461910000017213755865796066214_)"
    },
    d: "M17.6,91.7c0,8.5,0.3,16.4,0.8,23.7 c2.4,33.4,9.3,52.3,9.3,52.3h9C12.8,82.5,49.2,6.9,49.6,6c-0.4,0.5-20.5,24.4-28.7,58.2C18.9,72.8,17.6,82.1,17.6,91.7z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000183960876000880605790000012787938385766695834_",
    filterUnits: "userSpaceOnUse",
    x: 49.4,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 49.4,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000065787235843545441060000015899674216830614405_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000183960876000880605790000012787938385766695834_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000154401993242196735880000011232478197476751780_",
    filterUnits: "userSpaceOnUse",
    x: 49.4,
    y: 6,
    width: 32,
    height: 161.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 49.4,
    y: 6,
    width: 32,
    height: 161.7,
    id: "SVGID_00000065787235843545441060000015899674216830614405_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000154401993242196735880000011232478197476751780_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040545698393051251760000012114399833180802228_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.4757,
    y1: -817.6542,
    x2: 263.6394,
    y2: -985.821,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000065787235843545441060000015899674216830614405_)",
      fill: "url(#SVGID_00000040545698393051251760000012114399833180802228_)"
    },
    d: " M81.4,91.7c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3h-9C86.2,82.5,49.9,6.9,49.4,6c0.4,0.5,20.5,24.4,28.7,58.2 C80.1,72.8,81.4,82.1,81.4,91.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036940649192477272750000010194456900486637500_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.4757,
    y1: -817.6542,
    x2: 263.6394,
    y2: -985.821,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000036940649192477272750000010194456900486637500_)"
    },
    d: "M81.4,91.7 c0,8.5-0.3,16.4-0.8,23.7c-2.4,33.4-9.3,52.3-9.3,52.3h-9C86.2,82.5,49.9,6.9,49.4,6c0.4,0.5,20.5,24.4,28.7,58.2 C80.1,72.8,81.4,82.1,81.4,91.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008847797832080523940000012073892230318082948_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.4685,
    y1: 150.4473,
    x2: 66.4685,
    y2: 179.0848,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008847797832080523940000012073892230318082948_)"
    },
    points: "49.6,125.3 49.6,194.6  51.8,174.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010294458742673875320000000077965991545168567_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.6404,
    y1: 180.3284,
    x2: 68.6404,
    y2: 158.3005,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000010294458742673875320000000077965991545168567_)"
    },
    points: "49.6,125.3 49.6,194.6  47.4,174.2  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000087408882001809847920000012615113948189514686_",
    filterUnits: "userSpaceOnUse",
    x: 34.8,
    y: 77.4,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.8,
    y: 77.4,
    width: 28,
    height: 28,
    id: "SVGID_00000034060629245424291090000009667638545884830338_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000087408882001809847920000012615113948189514686_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000155839034324839073310000014027167010345117097_",
    filterUnits: "userSpaceOnUse",
    x: 34.8,
    y: 77.4,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.8,
    y: 77.4,
    width: 28,
    height: 28,
    id: "SVGID_00000034060629245424291090000009667638545884830338_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000155839034324839073310000014027167010345117097_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153707025043328952170000003311916855432133015_",
    gradientUnits: "userSpaceOnUse",
    x1: 352,
    y1: -833.6934,
    x2: 278.5253,
    y2: -882.6486,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      mask: "url(#SVGID_00000034060629245424291090000009667638545884830338_)",
      fill: "url(#SVGID_00000153707025043328952170000003311916855432133015_)"
    },
    cx: 48.8,
    cy: 91.4,
    r: 14
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109712990623798060760000003947007119269518743_",
    gradientUnits: "userSpaceOnUse",
    x1: 352,
    y1: -833.6934,
    x2: 278.5253,
    y2: -882.6486,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9979,
    style: {
      stopColor: "#06090F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000109712990623798060760000003947007119269518743_)"
    },
    cx: 48.8,
    cy: 91.4,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106858867842356280060000012174120240423262105_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5544,
    y1: 77.5643,
    x2: 67.5544,
    y2: 98.082,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000106858867842356280060000012174120240423262105_)"
    },
    cx: 49.6,
    cy: 90.6,
    r: 12.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161597503026240768770000004241000853689922716_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.0823,
    y1: 97.6653,
    x2: 65.474,
    y2: 87.3219,
    gradientTransform: "matrix(-1 0 0 1 117.1571 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09148491,
    style: {
      stopColor: "#14161C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#1E173A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5475,
    style: {
      stopColor: "#391B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6220FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161597503026240768770000004241000853689922716_)"
    },
    d: "M40.5,90.6c0,5,4.1,9.1,9.1,9.1 c1,0,1.9-0.2,2.8-0.4c1.1-0.4,2.2-0.9,3.1-1.7c0.7-0.6,1.3-1.3,1.8-2c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1 c-1.8,0-3.5,0.5-5,1.5c-0.8,0.5-1.4,1.1-2,1.8c-0.7,0.9-1.3,1.9-1.7,3.1C40.7,88.7,40.5,89.6,40.5,90.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000075879411841887319970000000876508357019976883_",
    filterUnits: "userSpaceOnUse",
    x: 44.6,
    y: 81.5,
    width: 14.1,
    height: 14.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 44.6,
    y: 81.5,
    width: 14.1,
    height: 14.1,
    id: "SVGID_00000125572675827083247090000018420712137460371369_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000075879411841887319970000000876508357019976883_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000164483886196755038730000004923316387949352073_",
    filterUnits: "userSpaceOnUse",
    x: 44.6,
    y: 81.5,
    width: 14.1,
    height: 14.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 44.6,
    y: 81.5,
    width: 14.1,
    height: 14.1,
    id: "SVGID_00000125572675827083247090000018420712137460371369_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000164483886196755038730000004923316387949352073_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052092532661586323550000016372341480132169150_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8008,
    y1: -854.3836,
    x2: 301.0899,
    y2: -810.6067,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000125572675827083247090000018420712137460371369_)",
      fill: "url(#SVGID_00000052092532661586323550000016372341480132169150_)"
    },
    d: " M44.6,83l12.6,12.6c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1C47.8,81.5,46.1,82,44.6,83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137113460341895398430000011281943004849367434_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.8008,
    y1: -854.3836,
    x2: 301.0899,
    y2: -810.6067,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000137113460341895398430000011281943004849367434_)"
    },
    d: "M44.6,83l12.6,12.6 c0.9-1.4,1.5-3.1,1.5-5c0-5-4.1-9.1-9.1-9.1C47.8,81.5,46.1,82,44.6,83z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026163456976159100230000015187083146293767324_",
    filterUnits: "userSpaceOnUse",
    x: 40.9,
    y: 84.8,
    width: 14.5,
    height: 14.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 40.9,
    y: 84.8,
    width: 14.5,
    height: 14.5,
    id: "SVGID_00000181070454830960083770000008390111164492733373_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000026163456976159100230000015187083146293767324_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000150812668143735924540000010120998587702120350_",
    filterUnits: "userSpaceOnUse",
    x: 40.9,
    y: 84.8,
    width: 14.5,
    height: 14.5
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 40.9,
    y: 84.8,
    width: 14.5,
    height: 14.5,
    id: "SVGID_00000181070454830960083770000008390111164492733373_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000150812668143735924540000010120998587702120350_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044178541357508685250000017001417030820663208_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.765,
    y1: -850.4369,
    x2: 346.7956,
    y2: -811.3622,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000181070454830960083770000008390111164492733373_)",
      fill: "url(#SVGID_00000044178541357508685250000017001417030820663208_)"
    },
    d: " M40.9,87.8l11.4,11.4c1.1-0.4,2.2-0.9,3.1-1.7L42.6,84.8C41.9,85.7,41.3,86.7,40.9,87.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065761730984228510270000014781439533655579580_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.765,
    y1: -850.4369,
    x2: 346.7956,
    y2: -811.3622,
    gradientTransform: "matrix(-1 0 0 1 392.2103 930.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "url(#SVGID_00000065761730984228510270000014781439533655579580_)"
    },
    d: "M40.9,87.8l11.4,11.4 c1.1-0.4,2.2-0.9,3.1-1.7L42.6,84.8C41.9,85.7,41.3,86.7,40.9,87.8z"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeWidget1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home-widget-1.bc207bece05cc152a27d84fdada104a9.svg";